import { Link } from 'react-router-dom';
import { useLocalizedPath } from '@/hooks/useI18n';
import { useTranslation } from '@/hooks/useTranslation';
import { Container } from '@/components/Container';

export function HeroSection() {
  const localize = useLocalizedPath();
  const { t } = useTranslation();

  return (
    <section className="relative h-[92vh] flex items-end overflow-hidden">
      <div className="absolute inset-0">
        <picture>
          <source srcSet="/images/praia-do-farol-hero.webp" type="image/webp" />
          <img
            src="/images/praia-do-farol-hero.jpg"
            alt={t('home.hero.imageAlt')}
            className="absolute inset-0 w-full h-full object-cover"
            width="1920"
            height="1080"
            fetchPriority="high"
            decoding="async"
          />
        </picture>
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-black/10" />
      </div>

      <Container className="relative z-10 pb-16 sm:pb-20 pt-32">
        <div className="max-w-3xl">
          <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl xl:text-6xl text-white mb-3 leading-[1.05] drop-shadow-lg max-w-4xl pt-8">
            {t('home.hero.title')}
          </h1>
          <p className="font-editorial text-xl sm:text-2xl lg:text-3xl text-white/90 mb-4 max-w-2xl">
            {t('home.hero.subtitle')}
          </p>
          <p className="font-body text-base sm:text-lg text-white/75 max-w-xl mb-8 leading-relaxed">
            {t('home.hero.description')}
          </p>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <Link
              to={localize('/como-chegar-na-ilha-do-mel')}
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 shrink-0 bg-coral hover:bg-[#c96a52] text-white font-body font-semibold rounded-xl px-4 sm:px-6 py-3 sm:py-4 transition-all hover:-translate-y-0.5 hover:shadow-lg hover:shadow-coral/30 uppercase tracking-wide text-center whitespace-nowrap text-xs sm:text-sm"
            >
              {t('home.hero.ctaPlan')}
              <svg className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                />
              </svg>
            </Link>
            <Link
              to={localize('/pousadas-ilha-do-mel')}
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 shrink-0 bg-white/15 hover:bg-white/25 border border-white/25 text-white font-body font-semibold rounded-xl px-4 sm:px-6 py-3 sm:py-4 transition-all hover:-translate-y-0.5 backdrop-blur-sm text-center whitespace-nowrap text-xs sm:text-sm"
            >
              {t('home.hero.ctaStays')}
            </Link>
          </div>
        </div>
      </Container>

      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 animate-bounce-slow">
        <svg
          className="w-6 h-6 text-white/60"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 14l-7 7m0 0l-7-7m7 7V3"
          />
        </svg>
      </div>
    </section>
  );
}
